import {
    EXPERTS_GET_STATUSES_LIST,
    EXPERTS_GET_STATUSES_LIST_SUCCESS,
    EXPERTS_GET_STATUSES_LIST_ERROR
} from './actions_def';

const INIT_STATE = {
    expertsStatuses: [],
    errors: [],
    isLoading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case EXPERTS_GET_STATUSES_LIST:
            return { ...state, isLoading: false };

        case EXPERTS_GET_STATUSES_LIST_SUCCESS:
            return {
                ...state,
                isLoading: true,
                expertsStatuses: action.payload,
            };

        case EXPERTS_GET_STATUSES_LIST_ERROR:
            return { ...state, isLoading: true, error: action.payload };


        default:
            return { ...state };
    }
};
